import { render, staticRenderFns } from "./activity-workshop-question.vue?vue&type=template&id=4b385a52&scoped=true&"
import script from "./activity-workshop-question.vue?vue&type=script&lang=js&"
export * from "./activity-workshop-question.vue?vue&type=script&lang=js&"
import style0 from "./activity-workshop-question.vue?vue&type=style&index=0&id=4b385a52&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b385a52",
  null
  
)

export default component.exports